import { createEl, createUrl, pushUrl, replaceUrl, parseCookies, testCookies } from "./utils.js";
import calendar from "./calendar.js";
import createAddForm from "./add-form.js";
import createDropdown from "./dropdown.js";
import snackbar from "./snackbar.js";

let root = null;

function home() {
    const cookies = parseCookies(document.cookie);

    if(typeof cookies.userId === "undefined") {
        replaceUrl("/login");
        return "";
    } else {
        cookies.userId = parseInt(cookies.userId, 10);
    }

    const [el, refs] = createEl();

    const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "Desember",
    ];

    let rooms = [];
    let reservations = [];
    const date = new Date();
    const url = new URL(window.location.href);

    const params = {
        roomId: parseInt(url.searchParams.get("room_id"), 10),
        year: parseInt(url.searchParams.get("year"), 10),
        month: parseInt(url.searchParams.get("month"), 10),
    };

    if(!Number.isNaN(params.year) && !Number.isNaN(params.month)
        && params.year >= 2000 && params.year <= 9999
        && params.month >= 1 && params.month <= 12) {
        date.setFullYear(params.year);
        date.setMonth(params.month - 1);
    } else if(!Number.isNaN(params.year) || !Number.isNaN(params.month)) {
        window.location.href = `${url.protocol}//${url.host}`;
    }

    async function fetchRooms() {
        try {
            testCookies();
            const response = await fetch(`/api/rooms`);
            if(response.ok) {
                const results = await response.json();
                return results;
            } else {
                const error = await response.json();
                snackbar.dispatch(`Error: ${error.message}`, "error");
                return [];
            }
        } catch(error) {
            snackbar.dispatch(`Error: ${error.message}`, "error");
            return [];
        }
    }

    async function fetchReservations(roomId, year, month) {
        try {
            testCookies();
            const url = createUrl("/api/reservations");
            url.searchParams.set("room_id", roomId);
            url.searchParams.set("year", year);
            url.searchParams.set("month", month);
            const response = await fetch(url)
            if(response.ok) {
                const results = await response.json();
                return results;
            } else {
                const error = await response.json();
                snackbar.dispatch(`Error: ${error.message}`, "error");
                return [];
            }
        } catch(error) {
            snackbar.dispatch(`Error: ${error.message}`, "error");
            return [];
        }
    }

    function renderReservation() {
        for(let i = 1; i <= 31; i++) {
            if(refs[`cal-${i}`]) {
                refs[`cal-${i}`].innerHTML = "";
            }
        }
        for(const reservation of reservations) {
            const item = el("p", `${reservation.start_time} - ${reservation.end_time} ${reservation.name}`);
            refs[`cal-${reservation.dom}`].append(item);
        }
    }

    function renderReservationForm(dom) {
        const elements = reservations
            .filter(item => item.dom === dom)
            .map(item => el("li", [
                el("div", [
                    el("p", `${item.start_time} - ${item.end_time} ${item.name}`),
                    el("p", `${item.description ? item.description : "-"}`),
                ]),
                el("div", [
                    el("button", {
                        "data-id": item.id.toString(),
                        class: "icon-button small",
                        style: item.user_id === cookies.userId ? "" : "display: none",
                    }, [
                        el("svg", {
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                        }, [
                            el("path", {
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M18 6V16.2C18 17.8802 18 18.7202 17.673 19.362C17.3854 19.9265 16.9265 20.3854 16.362 20.673C15.7202 21 14.8802 21 13.2 21H10.8C9.11984 21 8.27976 21 7.63803 20.673C7.07354 20.3854 6.6146 19.9265 6.32698 19.362C6 18.7202 6 17.8802 6 16.2V6M14 10V17M10 10V17"
                            }),
                        ]),
                    ]),
                ]),
            ]));

        refs.reservationList.innerHTML = "";
        if(elements.length > 0) {
            refs.reservationList.append(...elements);
        } else {
            refs.reservationList.append(el("li", { style: "text-align: center" }, "-- Empty --"));
        }
    }

    const roomDropdown = createDropdown({
        onSelect: onRoomSelect,
    });

    const container = el("main", {class: "container"}, [
        el("header", [
            el("h1", "Peminjaman Ruang FS"),
            el("div", [
                el("p", `${cookies.email} (${cookies.name})`),
                el("button", { ref: "logoutButton", class: "icon-button" }, [
                    el("svg", {
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                    }, [
                        el("path", {
                            d: "M21 12L13 12",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                        }),
                        el("path", {
                            d: "M18 15L20.913 12.087V12.087C20.961 12.039 20.961 11.961 20.913 11.913V11.913L18 9",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                        }),
                        el("path", {
                            d: "M16 5V4.5V4.5C16 3.67157 15.3284 3 14.5 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H14.5C15.3284 21 16 20.3284 16 19.5V19.5V19",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                        }),
                    ]),
                ]),
            ]),
        ]),
        el("nav", [
            el("div", { class: "calendar-control" }, [
                el("button", { ref: "prevMonthBtn" }, [
                    el("svg", {
                        viewBox:"0 0 24 24",
                        fill:"none",
                        xmlns:"http://www.w3.org/2000/svg"
                    }, [
                        el("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin":"round",
                            "stroke-width": "2",
                            "d": "M14 5l-7 7 7 7",
                        }),
                    ])
                ]),
                el("button", { ref: "nextMonthBtn" }, [
                    el("svg", {
                        viewBox:"0 0 24 24",
                        fill:"none",
                        xmlns:"http://www.w3.org/2000/svg"
                    }, [
                        el("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin":"round",
                            "stroke-width": "2",
                            "d": "M10 5l7 7-7 7",
                        }),
                    ])
                ]),
                el("p", [
                    el("span", { ref: "monthLabel" }, monthNames[date.getMonth()]),
                    el("span", `${String.fromCharCode(160)}`),
                    el("span", { ref: "yearLabel" }, date.getFullYear()),
                ]),
            ]),
            roomDropdown.root,
        ]),
        calendar(date.getFullYear(), date.getMonth() + 1, el, onDateClicked),
        createAddForm(el, refs, onAddFormSubmit, onAddFormDelete),
    ]);

    function onDateClicked(event) {
        const dateElem = event.currentTarget;
        if(dateElem.dataset.dom) {
            const year = parseInt(dateElem.dataset.year, 10);
            const month = parseInt(dateElem.dataset.month, 10);
            const dom = parseInt(dateElem.dataset.dom, 10);

            renderReservationForm(dom);

            refs.roomInput.value = roomDropdown.selected.value;
            refs.yearInput.value = year;
            refs.monthInput.value = month;
            refs.domInput.value = dom;

            refs.addFormRoomLabel.textContent = roomDropdown.selected.label;
            refs.addFormDateLabel.textContent = `${dom} ${monthNames[month - 1]} ${year}`;
            refs.addFormModal.showModal();
        }
    }

    async function onAddFormSubmit(data) {
        try {
            testCookies();
            const response = await fetch("/api/reservations", {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });

            if(response.ok) {
                const dom = parseInt(refs.domInput.value, 10);
                reservations = await response.json();
                renderReservation(reservations);
                renderReservationForm(dom);
            } else {
                const error = await response.json();
                throw error;
            }
        } catch(error) {
            throw error;
        }
    }

    async function onAddFormDelete(id) {
        try {
            testCookies();
            const response = await fetch(`/api/reservations/${id}`, {
                method: "delete",
            });

            if(response.ok) {
                const dom = parseInt(refs.domInput.value, 10);
                reservations = await response.json();
                renderReservation(reservations);
                renderReservationForm(dom);
            } else {
                const error = await response.json();
                throw error;
            }
        } catch(error) {
            throw error;
        }
    }

    async function onRoomSelect() {
        const snack = snackbar.dispatch("Loading...", "primary", 0);
        pushUrl(`/room/${roomDropdown.selected.value}/year/${date.getFullYear()}/month/${date.getMonth() + 1}`, false);
        reservations = await fetchReservations(roomDropdown.selected.value, date.getFullYear(), date.getMonth() + 1);
        renderReservation(reservations);
        snack.remove();
    }

    refs.nextMonthBtn.addEventListener("click", async () => {
        const snack = snackbar.dispatch("Loading...", "primary", 0);
        date.setMonth(date.getMonth() + 1);
        refs.monthLabel.textContent = monthNames[date.getMonth()];
        refs.yearLabel.textContent = date.getFullYear();
        const to = createUrl("/");
        to.searchParams.set("room_id", roomDropdown.selected.value);
        to.searchParams.set("year", date.getFullYear());
        to.searchParams.set("month", date.getMonth() + 1);
        pushUrl(to.toString(), false);
        refs.calendar.replaceWith(calendar(date.getFullYear(), date.getMonth() + 1, el, onDateClicked));
        reservations = await fetchReservations(roomDropdown.selected.value, date.getFullYear(), date.getMonth() + 1);
        renderReservation(reservations);
        snack.remove();
    });

    refs.prevMonthBtn.addEventListener("click", async () => {
        const snack = snackbar.dispatch("Loading...", "primary", 0);
        date.setMonth(date.getMonth() - 1);
        refs.monthLabel.textContent = monthNames[date.getMonth()];
        refs.yearLabel.textContent = date.getFullYear();
        const to = createUrl("/");
        to.searchParams.set("room_id", roomDropdown.selected.value);
        to.searchParams.set("year", date.getFullYear());
        to.searchParams.set("month", date.getMonth() + 1);
        pushUrl(to.toString(), false);
        refs.calendar.replaceWith(calendar(date.getFullYear(), date.getMonth() + 1, el, onDateClicked));
        reservations = await fetchReservations(roomDropdown.selected.value, date.getFullYear(), date.getMonth() + 1);
        renderReservation(reservations);
        snack.remove();
    });

    refs.logoutButton.addEventListener("click", async () => {
        await fetch("/logout");
        replaceUrl("/login");
    });

    (async () => {
        const snack = snackbar.dispatch("Loading...", "primary", 0);
        rooms = await fetchRooms();
        if(rooms.length > 0) {
            roomDropdown.setOptions(rooms.map(room => ({
                label: room.room_title,
                value: room.id,
            })));
            if(params.roomId) {
                roomDropdown.setSelected(params.roomId);
            }
            reservations = await fetchReservations(roomDropdown.selected.value, date.getFullYear(), date.getMonth() + 1);
            renderReservation(reservations);
        }
        snack.remove();
    })();

    return container;
}


export default () => {
    if(root === null) {
        root = home();
    }
    return root;
};
